import React, { Component } from "react";
import * as RequestActions from "../../../../actions/requestActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Drawer } from "@blueprintjs/core";
import LangSelect from "../../LangSelect";
import SearchInput from "../../SearchInput";
import "./index.css";
import { originUrl } from "../../../../api/apiConst";

class Navbar extends Component {
  _options = [
    {
      text: "Fa",
      icon: (
        <img
          src={require("../../../../assets/images/ir.svg")}
          alt=""
          height="15"
          width="20"
        />
      ),
    },
    {
      text: "En",
      icon: (
        <img
          src={require("../../../../assets/images/gb.svg")}
          alt=""
          height="15"
          width="20"
        />
      ),
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.clickHandler = this.clickHandler.bind(this);
    this.changeLang = this.changeLang.bind(this);
    this.langChangeHandler = this.langChangeHandler.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.selectNavItem = this.selectNavItem.bind(this);
  }

  componentDidMount() {
    this.selectNavItem("main-nav-bar-items");
    document.addEventListener("scroll", () => {
      this.handleScroll();
    });
  }

  selectNavItem(id) {
    let parent = document.getElementById(id);
    let route = window.location.pathname.split("/")[1];
    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (
        child &&
        child.dataset.tag.toLowerCase() === route.toLowerCase() &&
        child.dataset.tag.toLowerCase() !== "login"
      ) {
        child.style.backgroundColor = "rgba(129, 145, 154, 0.6)";
      } else {
        child.style.backgroundColor = "";
      }
    }
  }

  clickHandler(e) {
    const { history } = this.props;
    const target = e.target.dataset.tag;
    const parent = e.target.parentElement;
    if (target === "") {
      history.push("/");
    }
    if (target === "about") {
      history.push("/about");
    }
    if (target === "bloge") {
      history.push("/bloge");
    }
    if (target === "pricing") {
      history.push("/pricing");
    }
    if (target === "services") {
      history.push("/services");
    }
    if (target === "plans") {
      history.push("/plans");
    }
    if (target === "web-api") {
      history.push("/web-api");
    }
    if (target === "learning") {
      history.push("/learning");
    }
    if (target === "login") {
      window.location.href = window.location.origin + "/home/#";
    }

    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];
      if (
        child &&
        child.dataset.tag === target &&
        child.dataset.tag !== "Login"
      ) {
        child.style.backgroundColor = "rgba(129, 145, 154, 0.6)";
      } else {
        child.style.backgroundColor = "";
      }
    }
    this.setState({ isOpen: false });
  }

  changeLang() {
    const { lang } = this.props;
    var _lang = lang === "fa" ? "en" : "fa";
    this.props.changeLang(_lang);
  }

  langChangeHandler(lang) {
    this.props.changeLang(lang.text.toLowerCase());
  }
  handleOpen() {
    this.setState({ isOpen: true });
    setTimeout(() => {
      this.selectNavItem("flip-nav-bar-items");
    }, 20);
  }
  handleClose() {
    this.setState({ isOpen: false });
  }
  handleScroll() {
    var myNav = document.getElementById("main-bottom-navbar");
    if (myNav) {
      window.onscroll = function () {
        if (document.documentElement.scrollTop >= 100) {
          myNav.classList.add("main-bottom-navbar-colored");
          document.getElementById("main-top-navbar").style.height = "78px";
        } else {
          myNav.classList.remove("main-bottom-navbar-colored");
          document.getElementById("main-top-navbar").style.height = "39px";
        }
      };
    }
  }

  render() {
    const { lang } = this.props;
    return (
      <div id="main-navbar" className="main-navbar">
        <div id="main-top-navbar" className="top-navbar">
          {/* <SearchInput lang={ lang } placeholder={{fa:'جستجو',en:'Search'}} inputColor={'#000'}/> */}
          <h4 className="top-navbar-text">
            {lang === "fa"
              ? "شما هنوز وارد برنامه نشده اید"
              : "You are not logged in"}
            <span class="bvm-button">
              <a href="https://bv.emofid.com" target="_blank">
                <span>ورود به نسخه جدید</span>
                <img
                  alt=""
                  width={20}
                  height={20}
                  src={require("../../../../assets/images/sparkling-fill.svg")}
                />
              </a>
            </span>
          </h4>
          <h4 className="top-navbar-text">
            {lang === "fa"
              ? "سامانه جامع تحلیل بنیادی"
              : "The Financial Data Platform of IRAN Markets"}
          </h4>
          <a
            className="text-logo"
            href={originUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="mini-logo-white"></span>
            {lang === "fa" ? "بورس ویو" : "BourseView"}
          </a>
        </div>
        <div id="main-bottom-navbar" className="bottom-navbar">
          <LangSelect
            options={this._options}
            containerClass="lang-select-container"
            onChange={this.langChangeHandler}
          />

          <a
            className="telegram-icon"
            rel="noreferrer"
            target="_blank"
            href="https://t.me/bvhelp"
          >
            <span>{lang === "fa" ? "کانال تلگرام" : "Telegram"}</span>
            <div>
              <img
                alt=""
                width="100%"
                height="100%"
                src={require("../../../../assets/images/telegram.svg")}
              />
            </div>
          </a>
          <div className="phone-text">
            {/* <p style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }}>
              <span>{lang === 'fa' ? ' تلفن : ' : ' Phone : '}</span>
              {lang === 'fa' ? '81903000-021' : '+9821-81903000'}
            </p> */}
          </div>
          <nav className="nav-pages">
            <ul id="main-nav-bar-items">
              <li data-tag={"about"} onClick={this.clickHandler}>
                {lang === "fa" ? "درباره ما" : "About"}
              </li>
              <li data-tag={"learning"} onClick={this.clickHandler}>
                {lang === "fa" ? "آموزش" : "Learning"}
              </li>
              <li data-tag={"pricing"} onClick={this.clickHandler}>
                {lang === "fa" ? "تعرفه ها" : "Pricing"}
              </li>
              {/* <li data-tag={'web-api'} onClick={this.clickHandler}>{lang === 'fa' ? 'وب سرویس' : 'APIs'}</li> */}
              <li data-tag={"services"} onClick={this.clickHandler}>
                {lang === "fa" ? "خدمات" : "Services"}
              </li>
              <li data-tag={""} onClick={this.clickHandler}>
                {lang === "fa" ? "صفحه اصلی" : "Home"}
              </li>
              <li
                data-tag={"login"}
                className="enter-button"
                onClick={this.clickHandler}
              >
                {lang === "fa" ? "ورود به برنامه" : "Sign In"}
              </li>
            </ul>
          </nav>
          <div className="flip-nav-pages">
            <div onClick={this.handleOpen} className="flip-nav-pages-container">
              <span className="bp3-icon-large bp3-icon-menu"></span>
            </div>
          </div>
        </div>
        <Drawer
          icon="info-globe"
          style={{ backgroundColor: "rgb(0, 43, 68)", width: "auto" }}
          onClose={this.handleClose}
          title=""
          {...this.state}
        >
          <div className="flip-nav-portal-container">
            <ul id="flip-nav-bar-items">
              <li data-tag={"about"} onClick={this.clickHandler}>
                {lang === "fa" ? "درباره ما" : "About"}
              </li>
              <li data-tag={"learning"} onClick={this.clickHandler}>
                {lang === "fa" ? "آموزش" : "Learning"}
              </li>
              <li data-tag={"pricing"} onClick={this.clickHandler}>
                {lang === "fa" ? "تعرفه ها" : "Pricing"}
              </li>
              <li data-tag={"services"} onClick={this.clickHandler}>
                {lang === "fa" ? "خدمات" : "Services"}
              </li>
              <li data-tag={"web-api"} onClick={this.clickHandler}>
                {lang === "fa" ? "وب سرویس" : "APIs"}
              </li>
              <li data-tag={""} onClick={this.clickHandler}>
                {lang === "fa" ? "صفحه اصلی" : "Home"}
              </li>
              <li
                data-tag={"login"}
                className="enter-button"
                onClick={this.clickHandler}
              >
                {lang === "fa" ? "ورود به برنامه" : "Sign In"}
              </li>
            </ul>
          </div>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.request.lang,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...RequestActions,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
